var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewardDropIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.75627 15.0563L14.0063 26.3063C14.5556 26.8556 15.4444 26.8556 15.9938 26.3063L27.2438 15.0563C27.7931 14.5088 27.7931 13.6163 27.2438 13.0688C26.6963 12.5194 25.8038 12.5194 25.2563 13.0688L15 23.3231L4.74377 13.0688C4.19627 12.5194 3.30377 12.5194 2.75627 13.0688C2.20689 13.6163 2.20689 14.5088 2.75627 15.0563Z",
    fill: "#2C72DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.75627 5.68125L14.0063 16.9313C14.5556 17.4806 15.4444 17.4806 15.9938 16.9313L27.2438 5.68125C27.7931 5.13375 27.7931 4.24125 27.2438 3.69375C26.6963 3.14438 25.8038 3.14438 25.2563 3.69375L15 13.9481L4.74377 3.69375C4.19627 3.14438 3.30377 3.14438 2.75627 3.69375C2.20689 4.24125 2.20689 5.13375 2.75627 5.68125Z",
    fill: "#2C72DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardDropIcon);
export default __webpack_public_path__ + "static/media/reward-drop-icon.dd35ac25d947573659dbbd48a1cd6483.svg";
export { ForwardRef as ReactComponent };